import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { PasswordFormModel } from './password-create.model';

// ReactiveForm structure class
export default class PasswordForm {
  private formBuilder: FormBuilder;
  public formGroup: FormGroup;
  public model: PasswordFormModel;

  constructor(model: PasswordFormModel) {
    this.formBuilder = new FormBuilder();
    this.model = model;
    this.createForm();
  }
  // set form fields with validation rules
  public createForm() {
    this.formGroup = this.formBuilder.group({
      password: new FormControl(this.model.password, { validators: [Validators.required, Validators.minLength(5)], updateOn: 'blur'}),
      passwordConfirm: new FormControl(this.model.passwordConfirm, { validators: [Validators.required, Validators.minLength(5), Validators.pattern(this.model.password)], updateOn: 'blur'})
    });
    this.formGroup.valueChanges.subscribe(data => {
      this.model.passwordConfirm = data.passwordConfirm;
      this.model.password = data.password;
    });
  }
  // form update
  public patchForm(data: any): void {
    this.formGroup.patchValue(data);
    Object.keys(data).forEach(field => {
      this.model[field] = data[field];
    });
  }

  // get form property name
  public getControl(name: string) {
    return this.formGroup.get(name);
  }
}



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/components/password-create/password-create.form.ts